module.exports = __webpack_public_path__ + "media/country_flags/ve-262e54bf.png";